import React, { type JSX } from "react";
import { XMarkIcon, PlusIcon } from "@heroicons/react/24/outline";

const HAMBURGER_PATH =
  "M2.25 9C2.25 8.85082 2.30926 8.70774 2.41475 8.60225C2.52024 8.49676 2.66332 8.4375 2.8125 8.4375L15.1875 8.4375C15.3367 8.4375 15.4798 8.49676 15.5852 8.60225C15.6907 8.70774 15.75 8.85082 15.75 9C15.75 9.14919 15.6907 9.29226 15.5852 9.39775C15.4798 9.50324 15.3367 9.5625 15.1875 9.5625L2.8125 9.5625C2.66332 9.5625 2.52024 9.50324 2.41475 9.39775C2.30926 9.29226 2.25 9.14918 2.25 9ZM15.1875 12.9375L2.8125 12.9375C2.66332 12.9375 2.52024 12.9968 2.41475 13.1023C2.30926 13.2077 2.25 13.3508 2.25 13.5C2.25 13.6492 2.30926 13.7923 2.41475 13.8977C2.52024 14.0032 2.66332 14.0625 2.8125 14.0625L15.1875 14.0625C15.3367 14.0625 15.4798 14.0032 15.5852 13.8977C15.6907 13.7923 15.75 13.6492 15.75 13.5C15.75 13.3508 15.6907 13.2077 15.5852 13.1023C15.4798 12.9968 15.3367 12.9375 15.1875 12.9375ZM2.8125 5.0625L15.1875 5.0625C15.3367 5.0625 15.4798 5.00324 15.5852 4.89775C15.6907 4.79226 15.75 4.64919 15.75 4.5C15.75 4.35082 15.6907 4.20774 15.5852 4.10225C15.4798 3.99676 15.3367 3.9375 15.1875 3.9375L2.8125 3.9375C2.66332 3.9375 2.52024 3.99676 2.41475 4.10225C2.30926 4.20774 2.25 4.35082 2.25 4.5C2.25 4.64918 2.30926 4.79226 2.41475 4.89775C2.52024 5.00324 2.66332 5.0625 2.8125 5.0625Z";

/** Mobile + tablet only — desktop shows the sidebar permanently. */
export function SidebarToggleButton({
  isMobileSidebarOpen,
  onToggleSidebar,
}: {
  isMobileSidebarOpen: boolean;
  onToggleSidebar: () => void;
}): JSX.Element {
  return (
    <button
      onClick={onToggleSidebar}
      className="desktop:hidden p-2 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 mr-2"
      aria-label="Toggle navigation menu"
    >
      {isMobileSidebarOpen ? (
        <XMarkIcon className="h-6 w-6 text-gray-600" />
      ) : (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d={HAMBURGER_PATH} fill="#234E81" />
        </svg>
      )}
    </button>
  );
}

/** Tablet-only shortcut — mobile and desktop start new chats from the sidebar. */
export function NewChatButton({ onClick }: { onClick: () => void }): JSX.Element {
  return (
    <button
      onClick={onClick}
      className="hidden tablet:inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-cvc-blue text-cvc-blue text-sm font-medium hover:bg-cvc-blue/5 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200 mr-3"
      aria-label="New chat"
    >
      <PlusIcon className="h-4 w-4" />
      New
    </button>
  );
}

export function AboutDealOsButton({ onClick }: { onClick: () => void }): JSX.Element {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex items-center gap-1 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200"
      aria-label="About DealOS"
    >
      <span
        className="text-xs font-cvcBody px-2.5 py-1 rounded-l-full"
        style={{ color: "#234E81", backgroundColor: "rgba(35,78,129,0.1)" }}
      >
        About DealOS
      </span>
      <span
        className="text-xs font-cvcBody px-2.5 py-1 rounded-r-full"
        style={{ color: "#009174", backgroundColor: "rgba(0,145,116,0.2)" }}
      >
        BETA
      </span>
    </button>
  );
}
